import { toRem } from "lib/client/fonts";
import styled from "styled-components";

const SFacts = styled.ul`
	list-style: none;
	padding: 0;
	margin: 0;
	display: flex;
	gap: 20px;
	row-gap: 0;
	flex-direction: row;
	flex-wrap: wrap;

	@media screen and (min-width: 641px) {
		gap: 30px;
		flex-wrap: nowrap;
	}

	li {
		font-size: 1rem;
		font-weight: bold;
		text-transform: uppercase;

		@media screen and (max-width: 640px) {
			&.genre {
				width: 100%;
			}
		}

		@media screen and (min-width: 641px) {
			font-size: ${toRem(20)};
		}
	}
`;

export default SFacts;